import React, { useState, useEffect, useRef } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import "../assets/css/candidate-tab-form.css";
import ABUpload from "./Common/ABUpload";
import {
  getDocRegistration,
  saveDocRegistration,
  deleteSaveDocRegistration,
} from "../Actions/doctorRegistrationActions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./Common/loader";
import _ from "lodash";
import EMPText from "./EmploymentForm/empText";
import EMPMultipleUpload from "./EmploymentForm/empMultipleUpload";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer.js";
import StepCount from "./Common/StepCount";
import { validateAlphabetsAndSpace } from "../Helper/common";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import ProgressHeading from "./Common/ProgressHeading.jsx";

const CandidateDoctorRegistration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const storeData = useSelector((state) => state.docRegistration);
  const storeData2 = useSelector((state) => state.docRegistrationSaveData);

  const { docRegistrationData, loading: docRegistrationLoading } = storeData;
  const { docRegistrationSaveData, loading: docRegistrationSaveLoading } =
    storeData2;

  const [isLoading, setIsLoading] = useState(false);
  const [docDetails, setDocDetails] = useState({});
  const [unsavedDocDetails, setUnsavedDocDetails] = useState({});
  const [errorData, setErrorData] = useState({});
  const [unsavedErrorData, setUnsavedErrorData] = useState({});
  const [uploadedFilesCount, setUploadedFilesCount] = useState({});
  const [role,setRole]=useState();
  //Handling Form Reference
  const form = useRef();

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    doctorName: null,
    doctorRegistrationNumber: null,
  });

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    const fetchData = async () => {
      dispatch(getDocRegistration());
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (
      typeof docRegistrationLoading !== "undefined" &&
      docRegistrationLoading !== null
    ) {
      if (docRegistrationLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [docRegistrationData]);

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    if (
      typeof docRegistrationData.data !== "undefined" &&
      docRegistrationData.data !== null
    ) {
      if (Object.keys(unsavedDocDetails).length == 0) {
        setInitialData(docRegistrationData.data.data);
      } else {
        const updatedUploadedDocs = docRegistrationData.data.data
          .checksDetails[0].uploaded_documents
          ? docRegistrationData.data.data.checksDetails[0].uploaded_documents
          : null;
        const newData = _.cloneDeep(unsavedDocDetails);
        if (updatedUploadedDocs) {
          newData.checksDetails[0].uploaded_documents =
            _.cloneDeep(updatedUploadedDocs);
          setInitialData(newData);
        } else {
          newData.checksDetails[0].uploaded_documents = [];
          setInitialData(newData);
        }
      }
    }
  }, [docRegistrationData, storeData]);

  const setInitialData = (docRegistrationData) => {
    setDocDetails(docRegistrationData);
    createErrorData(docRegistrationData);
    getUploadedFilesCount(docRegistrationData.checksDetails);
  };
  useEffect(() => {
    if (
      typeof docRegistrationSaveData.data !== "undefined" &&
      docRegistrationSaveData.data !== null
    ) {
      const groupId = docRegistrationSaveData.data.group.group_id;
      const userLocalData = JSON.parse(
        localStorage.getItem("userVerificationCandidate")
      );
      if (groupId == "profile_preview") {
        navigate(
          `/case-initiation/profile-preview/${userLocalData.reference_number}`
        );
      } else {
        navigate(
          `/case-initiation/check-detail/${userLocalData.reference_number}/${groupId}`
        );
      }
      dispatch(deleteSaveDocRegistration());
    }
  }, [docRegistrationSaveData, storeData2]);

  const getUploadedFilesCount = (checksDetails) => {
    let uploadedFilesCount = {};
    for (let i in checksDetails) {
      let obj = {};
      for (let j in checksDetails[i].required_documents) {
        let count = 0;
        for (let k in checksDetails[i].uploaded_documents) {
          if (
            checksDetails[i].uploaded_documents[k].document_id ==
            checksDetails[i].required_documents[j].id
          ) {
            count++;
          }
        }
        obj[`${checksDetails[i].required_documents[j].id}`] = count;
      }
      uploadedFilesCount[i] = obj;
    }
    setUploadedFilesCount(uploadedFilesCount);
  };

  const createErrorData = (data) => {
    const errorObj = {};
    const fields = _.cloneDeep(data.checksDetails[0].fields);
    for (var i in fields) {
      if (i != "is_document_provided") {
        errorObj[`${i}`] = false;
      }
    }
    const requiredDocs = _.cloneDeep(data.checksDetails[0].required_documents);
    for (var i in requiredDocs) {
      if (requiredDocs[i].is_mandatory == 1) {
        errorObj[`${requiredDocs[i].document_name}`] = false;
      }
    }
    if (Object.keys(unsavedErrorData).length == 0) {
      setErrorData(errorObj);
    }
  };

  const handleTextChange = (textValues) => {
    const { dataset, value } = textValues;
    if (dataset.fieldname == "doctor_name") {
      const isValid = validateAlphabetsAndSpace(value);
      handleErrorData(dataset.fieldname, !isValid);
    } else {
      handleErrorData(dataset.fieldname, false);
    }
    const updatedDocDetails = _.cloneDeep(docDetails);
    updatedDocDetails.checksDetails[0].fields[dataset.fieldname].field_value =
      value;
    setDocDetails(updatedDocDetails);
  };

  const handleErrorData = (field, val) => {
    let newData = _.cloneDeep(errorData);
    newData[field] = val;
    setErrorData(newData);
  };
  const getUpdatedDocDetails = () => {
    const data = _.cloneDeep(docDetails);
    const unsavedErr = _.cloneDeep(errorData);
    setUnsavedDocDetails(data);
    setUnsavedErrorData(unsavedErr);
    dispatch(getDocRegistration());
  };

  const saveHandler = (e, caseCheckId) => {
    e.preventDefault();
    setIsLoading(true);
    const checksDetailsData = _.cloneDeep(docDetails.checksDetails[0]);
    let updatedErrorData = _.cloneDeep(errorData);
    for (var i in checksDetailsData.fields) {
      if (i !== "is_document_provided") {
        if (
          checksDetailsData.fields[i].field_value == "" ||
          checksDetailsData.fields[i].field_value == null
        ) {
          updatedErrorData[`${i}`] = true;
        }
      }
    }
    if (checksDetailsData.uploaded_documents) {
      const requiredDocs = _.cloneDeep(checksDetailsData.required_documents);
      const uploadedDocs = _.cloneDeep(checksDetailsData.uploaded_documents);
      for (var i in requiredDocs) {
        if (requiredDocs[i].is_mandatory == 1) {
          let docNotUploaded = true;
          const docID = requiredDocs[i].id;
          for (var j in uploadedDocs) {
            if (uploadedDocs[j].document_id == docID) {
              docNotUploaded = false;
            }
          }
          updatedErrorData[`${requiredDocs[i].document_name}`] = docNotUploaded;
        }
      }
    } else {
      const requiredDocs = _.cloneDeep(checksDetailsData.required_documents);
      for (var i in requiredDocs) {
        if (requiredDocs[i].is_mandatory == 1) {
          updatedErrorData[`${requiredDocs[i].document_name}`] = true;
        }
      }
    }

    let hasError = false;
    for (var i in updatedErrorData) {
      if (updatedErrorData[i] == true) {
        hasError = true;
        setIsLoading(false);
        break;
      }
    }
    setErrorData(updatedErrorData);
    if (!hasError) {
      saveDetails(caseCheckId);
    }
  };

  const saveDetails = (caseCheckId) => {
    let finalData = {};
    for (var i in docDetails.checksDetails[0].fields) {
      if (i !== "is_document_provided") {
        finalData[`${docDetails.checksDetails[0].fields[i].id}`] =
          docDetails.checksDetails[0].fields[i].field_value;
      }
    }
    let apiData = {};
    apiData[`${caseCheckId}`] = finalData;
    apiData[`${caseCheckId}`]["group"] = "doc_registration";
    dispatch(saveDocRegistration(caseCheckId, apiData));
  };
  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };
  return (
    <>
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        {isLoading && <Loader />}
        {Object.keys(docDetails).length > 0 && (
          <div className="container-fluid">
            <div className="row">
              <div className="col-auto w-100-mbl bg-gray-mbl">
               <ProgressHeading/>
                <CandidateTab activeTab={"Doctor's Registration"} />
              </div>
              <div className="col bg-gray-mbl">
                <form ref={form} className="p-3 form2 form-section">
                  <StepCount activeTab={"Doctor's Registration"} />
                  <h2 className="fnt-smi-bld">Doctor’s Registration</h2>
                  <p className="text-muted">
                    Add your doctor’s registration details.
                  </p>
                  <hr />
                  <div className="row">
                    {Object.keys(docDetails.checksDetails[0].fields).map(
                      (field, key) => {
                        const fields = _.cloneDeep(
                          docDetails.checksDetails[0].fields
                        );
                        return (
                          <>
                            {field !== "is_document_provided" && (
                              <EMPText
                                fieldValue={fields[field].field_value}
                                label={fields[field].label}
                                isRequired={fields[field].is_mandatory}
                                fieldName={field}
                                handleTextChange={handleTextChange}
                                hasError={errorData[field]}
                                errId={`${field}-doc`}
                              />
                            )}
                          </>
                        );
                      }
                    )}
                  </div>
                  <p></p>
                  <h6 className="fnt-smi-bld mb-0">Upload Document</h6>
                  <small className="text-muted">
                    Upload your related documents
                  </small>
                  <p></p>

                  {docDetails.checksDetails[0].required_documents &&
                    Object.entries(
                      docDetails.checksDetails[0].required_documents
                    ).map(([key, value]) => {
                      const totalCount =
                        uploadedFilesCount[0] && uploadedFilesCount[0][value.id]
                          ? uploadedFilesCount[0][value.id]
                          : 0;
                      const caseCheckId =
                        docDetails.checksDetails[0].case_check_id;
                      return (
                        <>
                          <EMPMultipleUpload
                            name={value.id}
                            id={value.id}
                            title={value.document_name}
                            record={{
                              caseCheckId: caseCheckId,
                              docId: value.id,
                            }}
                            totalCount={totalCount}
                            getUpdatedEmploymentData={getUpdatedDocDetails}
                            isMandatory={!!(value.is_mandatory == 1)}
                          />

                          {errorData[`${value?.document_name}`] &&
                            totalCount == 0 &&
                            value.is_mandatory == 1 && (
                              <p className="err text-danger">
                                This is a required field.
                              </p>
                            )}
                        </>
                      );
                    })}

                  {/* <EMPMultipleUpload
                    name="prescription_slip"
                    id="prescription_slip"
                    title="Prescription Slip"
                    record={{
                      caseCheckId: docDetails.checksDetails[0].case_check_id,
                      docId:
                        docDetails.checksDetails[0].required_documents[0].id,
                    }}
                    totalCount={
                      uploadedFilesCount[0] &&
                      uploadedFilesCount[0][
                        docDetails.checksDetails[0].required_documents[0].id
                      ]
                        ? uploadedFilesCount[0][
                            docDetails.checksDetails[0].required_documents[0].id
                          ]
                        : 0
                    }
                    getUpdatedEmploymentData={getUpdatedDocDetails}
                  />
                  {errorData["Prescription Slip"] && (
                    <p className="err text-danger">This is a required field.</p>
                  )}
                  <EMPMultipleUpload
                    name="doc_reg_certificate"
                    id="doc_reg_certificate"
                    title="Doctor's Registration Certificate"
                    record={{
                      caseCheckId: docDetails.checksDetails[0].case_check_id,
                      docId:
                        docDetails.checksDetails[0].required_documents[1].id,
                    }}
                    totalCount={
                      uploadedFilesCount[0] &&
                      uploadedFilesCount[0][
                        docDetails.checksDetails[0].required_documents[1].id
                      ]
                        ? uploadedFilesCount[0][
                            docDetails.checksDetails[0].required_documents[1].id
                          ]
                        : 0
                    }
                    getUpdatedEmploymentData={getUpdatedDocDetails}
                  />
                  {errorData["Doctor's Registration Certificate"] && (
                    <p className="err text-danger">This is a required field.</p>
                  )} */}
                  <div className="row mt-3">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) =>
                          saveHandler(
                            e,
                            docDetails.checksDetails[0].case_check_id
                          )
                        }
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  {docDetails.showProfilePreview == 1 && (
                    <div className="row">
                      <div className="col-auto d-flex justify-content-between">
                        <button
                          className="btn btn-primary btn-lg btn-block mt-3"
                          onClick={(e) => handleSubmitForPreview(e)}
                        >
                          {clientId == 459831 ? "Preview" : "Submit for Preview"}
                        </button>
                      </div>
                      <div className="col-auto d-flex justify-content-between mt-4">
                        <small className="text-muted">
                          Please complete all the mandatory fields before final
                          submission
                        </small>
                      </div>
                    </div>
                  )}
                </form>

                {/*Form*/}

                <Footer />
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};
export default CandidateDoctorRegistration;
